export const logoutResMock: void = void 0;
